import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/services/axios'
import router from '@/router'

import user from './user'
import settings from './settings'
import dashboard from './dashboard'
import reseller from './reseller'
import salesOrders from './sales-orders'
import discounts from './discounts'
import catalogue from './catalogue'
import channel from './channel'
import warehouse from './warehouse'
import app from './app'
import { SET as SET_APP, FETCHED as APP_FETCHED } from './app/types'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    app,
    user,
    settings,
    dashboard,
    reseller,
    salesOrders,
    discounts,
    catalogue,
    channel,
    warehouse,
  },
  state: {},
  mutations: {},
  actions: {
    async appClientInit({ commit, rootState }) {
      try {
        const { data: response } = await axios.get('/data/admin')
        const { message: data } = response

        commit(SET_APP, {
          title: data.logo_url,
          type: data.seller_type,
          name: data.vendor_name,
          id: data.vendor_hashid,
          logo: data.logo_url,
          show_attr_list: data.show_attr_list ? data.show_attr_list : 0,
        })
      } catch (err) {
        router.push('/auth/404').catch(e => {})
      }

      commit(APP_FETCHED)
    },
  },
})
